import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import Select from 'react-select';
import { createFundExpense, updateFundExpense } from '../../../api/ClubFundAPI';
import { handleApiError } from '../../../api/risapi';

const RecordExpenseForm = ({ editingRecord, expenseHeads, onSuccess, onCancel }) => {
    const isEditMode = !!editingRecord;
    const initialFormState = { head_of_account_id: null, amount: '', expense_date: new Date().toISOString().slice(0, 10), remarks: '' };
    const [formData, setFormData] = useState(initialFormState);
    const [errors, setErrors] = useState({});
    const [isSaving, setIsSaving] = useState(false);
    
    useEffect(() => {
        if (isEditMode && editingRecord) {
            setFormData({
                head_of_account_id: { value: editingRecord.head_of_account_id, label: editingRecord.head_of_account?.name },
                amount: editingRecord.amount,
                expense_date: editingRecord.expense_date,
                remarks: editingRecord.remarks,
            });
        }
    }, [editingRecord, isEditMode]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };
    const handleSelectChange = (name, selectedOption) => {
        setFormData(prev => ({ ...prev, [name]: selectedOption }));
    };

    const handleSubmit = () => {
        setIsSaving(true);
        const apiCall = isEditMode ? updateFundExpense : createFundExpense;
        const payload = { ...formData, id: editingRecord?.id, head_of_account_id: formData.head_of_account_id?.value };
        
        apiCall(payload, (response) => {
            setIsSaving(false);
            if (response.expense) {
                Swal.fire('Success!', `Expense ${isEditMode ? 'updated' : 'recorded'} successfully!`, 'success');
                onSuccess();
            } else {
                handleApiError(response, setErrors);
                Swal.fire('Error!', 'Please check the form for errors.', 'error');
            }
        });
    };

    const headOptions = expenseHeads.map(h => ({ value: h.id, label: h.name }));

    return (
        <div className="col-12">
            <div className="card mb-4">
                <div className="card-header d-flex justify-content-between">
                    <h5>{isEditMode ? 'Edit' : 'Record New'} Expense</h5>
                    <button type="button" className="btn-close" onClick={onCancel}></button>
                </div>
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-6 mb-3"><label className="form-label">Expense Date *</label><input type="date" className="form-control" name="expense_date" value={formData.expense_date} onChange={handleInputChange} />{errors.expense_date && <div className="text-danger small">{errors.expense_date}</div>}</div>
                        <div className="col-md-6 mb-3"><label className="form-label">Amount (₹) *</label><input type="number" className="form-control" name="amount" value={formData.amount} onChange={handleInputChange} />{errors.amount && <div className="text-danger small">{errors.amount}</div>}</div>
                        <div className="col-12 mb-3"><label className="form-label">Head of Account (Expense) *</label><Select options={headOptions} value={formData.head_of_account_id} onChange={(opt) => handleSelectChange('head_of_account_id', opt)} />{errors.head_of_account_id && <div className="text-danger small">{errors.head_of_account_id}</div>}</div>
                        <div className="col-12 mb-3"><label className="form-label">Remarks / Description *</label><input type="text" className="form-control" name="remarks" value={formData.remarks} onChange={handleInputChange} />{errors.remarks && <div className="text-danger small">{errors.remarks}</div>}</div>
                    </div>
                </div>
                <div className="card-footer text-end">
                    <button className="btn btn-primary" onClick={handleSubmit} disabled={isSaving}>
                        {isSaving ? 'Saving...' : (isEditMode ? 'Update Expense' : 'Save Expense')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default RecordExpenseForm;
